import AngleManager from "../../AngleManager";
import PointManager from "../../PointManager";
import MoveAngle from "../../../animations/MoveAngleAnimation";
import ReduceOpacityAnim from "../../../animations/ReduceOpacityAnimation";
import calcAngles from "../../../../../../../src/utils/math/calcAngles";
import Circle from "../../../../../../../src/entities/Circle";
import { Coord } from "../../../../../../../src/types/Interface";
import Angle from "../../../../../../../src/entities/Angle/Angle";
import { addCustomDelay } from "../../../../../../../src/animation/Circle/helpers/drawHelpers";


export async function drawMoveAngles(circle: Circle, PointManager: PointManager, AngleManager: AngleManager): Promise<void> {
  const radians = PointManager.getInitialRadians();
  const points = PointManager.getRedPoints()
  const angles = calcAngles(points[2], points[0], points[1]);

  AngleManager.cloneCircumAngles.forEach(angle => {
    angle.alpha = 1;
    angle.AngleValue.alpha = 1;
    drawCloneAngle(angle, { coord: points[2], startRadian: angles.startRadian, endRadian: angles.endRadian });
  });
  
  await drawMoveAngle(AngleManager.cloneCircumAngles[0], { x: circle.x, y: circle.y }, radians[0], Math.PI / 2);
  await drawMoveAngle(AngleManager.cloneCircumAngles[1], { x: circle.x, y: circle.y }, Math.PI / 2, radians[1]);
  
  AngleManager.cloneCircumAngles.forEach((cAngle) => {
    drawReduceOpacityAnim(cAngle);
    drawReduceOpacityAnim(cAngle.AngleValue)
  });

  await addCustomDelay(1000)
}

async function drawMoveAngle(Angle: Angle, coord: Coord, sRadian: number, endRadian: number): Promise<void>{ 
  return new Promise((resolve) => {
    new MoveAngle(Angle, coord, sRadian, endRadian, drawCloneAngle, resolve, resolve);
  })
}

async function drawReduceOpacityAnim(Angle: any): Promise<void> {
  return new Promise((resolve) => {
    new ReduceOpacityAnim(Angle, resolve, resolve);
  });
}

function drawCloneAngle(angle: Angle, Detail: { coord: Coord, startRadian: number, endRadian: number }) {
  const { coord, startRadian, endRadian } = Detail;
  angle.draw(coord, startRadian, endRadian, 50, false);
  angle.AngleValue.setValue("x");
  angle.x = coord.x;
  angle.y = coord.y;
}